import { verifyUserIdentification } from 'constants/routes';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError, map } from 'rxjs';
import { camelCaseObjectKeys } from 'utils/camelCase';
import { getAntiForgeryToken } from '../services/antiForgeryTokenService';

/**
 * Verifies user identification by sending a POST request with the provided specId and verificationId.
 *
 * @function
 * @param {Object} params - The parameters for the verification request.
 * @param {string} params.specId - The specification ID for the user verification.
 * @param {string} params.verificationId - The verification ID for the user verification.
 * @returns {Observable<Object>} An observable that emits the response data or an error object.
 */
const verifyUserIdentification$ = ({ specId, verificationId }) =>
  fromFetch(verifyUserIdentification, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({ specId, verificationId }),
    headers: {
      'Content-Type': 'application/json',
      'RequestVerificationToken': getAntiForgeryToken(),
    },
  }).pipe(
    switchMap(async (response) => {
      if (response.ok) {
        const data = await response.json();
        return data;
      }
      return of({ error: true, message: 'Error fetching data' });
    }),
    map(camelCaseObjectKeys),
    catchError((error) => of({ error: true, message: error.message }))
  );

export default verifyUserIdentification$;
